import { createFileRoute } from "@tanstack/react-router";
import SaintYouTube from "@/pages/SaintYouTube";
export const Route = createFileRoute("/saint-youtube")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          name: "robots",
          content: "noindex, follow",
        },
        {
          title: "SAINT® TMS in Coral Springs, FL | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "5-day, fMRI-guided SAINT® TMS for treatment-resistant depression. Verified SAINT Provider in Coral Springs, FL, serving Florida and out-of-state patients.",
        },
        {
          property: "og:title",
          content: "SAINT® TMS in Coral Springs, FL | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "5-day, fMRI-guided SAINT® TMS for treatment-resistant depression. Verified SAINT Provider in Coral Springs, FL, serving Florida and out-of-state patients.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/saint-youtube",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/saint-youtube",
        },
      ],
    };
  },
});
function RouteComponent() {
  return (
    <SaintYouTube
      source="saint-youtube"
      redirectTo="/thank-you-saint-youtube"
    />
  );
}
